import type { GameCommand } from '@bioforge/game-core';
import { COMMAND_CODES, type JournalCommand } from '@bioforge/protocol';

/**
 * Журнал партии соло (SPEC.md, 5.3; DECISIONS.md, D-019): один символ на принятую движком команду.
 * Сервер воспроизводит журнал и сам определяет итог.
 */
export class Journal {
  private codes: string[] = [];

  /** Записывает принятую команду. Команды, которых нет в соло (атаки, выбор капсулы), — ошибка. */
  record(command: GameCommand): void {
    if (command.type === 'use-ability' && command.slot !== 0) {
      throw new Error('В соло есть только слот способности 0');
    }
    if (!(command.type in COMMAND_CODES)) {
      throw new Error(`Команда ${command.type} не записывается в журнал соло`);
    }
    this.codes.push(COMMAND_CODES[command.type as JournalCommand]);
  }

  get length(): number {
    return this.codes.length;
  }

  toString(): string {
    return this.codes.join('');
  }
}
